module.exports = __webpack_public_path__ + "static/media/1.be88f87f.jpg";